import { z } from 'zod';
import { BOARD_TYPES } from '../enums';
import { isoDate, uuid } from './common';
import { itemFilterSchema } from './work-items';

export const createSprintSchema = z.object({
  name: z.string().min(1).max(80).optional(),
  goal: z.string().max(1000).optional(),
  startDate: isoDate.optional(),
  endDate: isoDate.optional(),
  capacityPoints: z.number().min(0).max(10000).optional(),
});
export type CreateSprintInput = z.infer<typeof createSprintSchema>;

export const updateSprintSchema = createSprintSchema.partial();
export type UpdateSprintInput = z.infer<typeof updateSprintSchema>;

export const startSprintSchema = z.object({
  startDate: isoDate,
  endDate: isoDate,
  goal: z.string().max(1000).optional(),
});
export type StartSprintInput = z.infer<typeof startSprintSchema>;

/** Carry-over of incomplete items (FR-PLN-2): to the backlog or another sprint. */
export const completeSprintSchema = z.object({ moveIncompleteTo: z.union([z.literal('backlog'), uuid]) });
export type CompleteSprintInput = z.infer<typeof completeSprintSchema>;

export const boardColumnSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1).max(60),
  statusIds: z.array(uuid),
  wipLimit: z.number().int().min(0).nullable().optional(),
});
export type BoardColumn = z.infer<typeof boardColumnSchema>;

export const boardConfigSchema = z.object({
  columns: z.array(boardColumnSchema).min(1),
  swimlane: z.enum(['none', 'assignee', 'epic', 'priority']).default('none'),
  quickFilters: z
    .array(z.object({ id: z.string(), name: z.string().min(1).max(40), filter: itemFilterSchema.partial() }))
    .default([]),
  /** Triage statuses are hidden from developer boards (FR-WF-8). */
  hideTriage: z.boolean().default(true),
});
export type BoardConfig = z.infer<typeof boardConfigSchema>;

export const createBoardSchema = z.object({
  name: z.string().min(1).max(80),
  type: z.enum(BOARD_TYPES),
  config: boardConfigSchema.optional(),
});
export type CreateBoardInput = z.infer<typeof createBoardSchema>;

export const updateBoardSchema = z.object({
  name: z.string().min(1).max(80).optional(),
  config: boardConfigSchema.optional(),
});
export type UpdateBoardInput = z.infer<typeof updateBoardSchema>;
